<template>
  <section class="container">
    <div class="error">
      <div class="error__left">
        <p class="error__icon" data-title="ERROR">
          <span>ERROR</span>
        </p>
      </div>

      <div class="error__right">
        <p class="error__text">{{ $t('error.message.linkBroken') }}<br />{{ $t('error.message.returnOrRetry') }}</p>
        <router-link class="error__button" to="/">
          {{ $t('common.button.returnHome') }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>
